import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService, PermissionService } from '@abp/ng.core';

@Injectable({
  providedIn: 'root',
})
export class AppAccessGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private permissionService: PermissionService,
    private router: Router,
  ) {}

  canActivate(): boolean {
    const allowed = this.permissionService.getGrantedPolicy('Goliath.App.Access');

    if (this.authService.isAuthenticated && !allowed) {
      this.router.navigate(['/access-denied']);
      return false;
    }

    return true;
  }
}
